import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';

// Shared Firebase project across WBD ContentLab apps (gcp-virtual-production-lab).
// Auth (Okta OIDC) is shared with LabOS — signing in here uses the same identity.
// Firebase configuration loaded from environment variables.
// For deployment: Set FRONTEND_VARIABLES repository variable in GitHub (Settings → Secrets and variables → Actions).
// For local development: Create frontend/.env.local with your Firebase config.
const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
};

if (!firebaseConfig.apiKey || !firebaseConfig.projectId) {
  throw new Error(
    'Firebase configuration missing. Ensure environment variables are set:\n' +
      '  - VITE_FIREBASE_API_KEY\n' +
      '  - VITE_FIREBASE_PROJECT_ID\n' +
      '  - VITE_FIREBASE_AUTH_DOMAIN\n' +
      '  - VITE_FIREBASE_STORAGE_BUCKET\n' +
      '  - VITE_FIREBASE_MESSAGING_SENDER_ID\n' +
      '  - VITE_FIREBASE_APP_ID\n' +
      '\nFor local dev: Create frontend/.env.local\n' +
      'For deployment: Set FRONTEND_VARIABLES in GitHub repository settings',
  );
}

export const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
